.cost-input {
  height: 24px;
  label {
    min-width: fit-content;
  }
}

.cost-input-disabled {
  border: none;
  background-color: var(--white);
  input {
    background: var(--white);
  }
}

.currency-symbol-disabled {
  background: var(--white);
}
